import React from 'react';
import styles from './index.module.scss';
import cls from 'classnames';

const Indicator = props => {
  const {
    currentIndex,
    count,
    onChange,
    className
  } = props;
  const list = Array.from({
    length: count
  }, () => 0);
  return /*#__PURE__*/React.createElement("div", {
    className: cls(styles.indicator, className)
  }, list.map((_, index) => /*#__PURE__*/React.createElement("span", {
    key: index,
    className: cls({
      [styles.current]: index === currentIndex
    }),
    onClick: () => {
      onChange === null || onChange === void 0 ? void 0 : onChange(index);
    }
  })));
};

export default Indicator;